import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
} from '@mui/material';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './CalendarStyles.css';
import MDTypography from '../../components/MDTypography';
import GenericTable from '../genericTable';
import { createMRTColumnHelper } from 'material-react-table';
import dayjs from 'dayjs';
import apiService from '../../services/api-service';
import showToast from '../../utils/toast';

function MachineryDateCopy({ open, onClose, onCopyMachineries }) {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [machineries, setMachineries] = useState([]);
  const columnHelper = createMRTColumnHelper();

  const tileDisabled = ({ date }) => {
    const today = new Date();
    return date > today;
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    apiService
      .get(
        '/daily-machines-management/',
        {
          area: localStorage.getItem('areaSelected'),
          date: dayjs(newDate).format('YYYY-MM-DD'),
        },
        {}
      )
      .then((data) => {

        console.log(data);
        const transformedData = data.map(machine => ({
          ...machine,
          selected: true,
          view_on_GDL: machine.view_on_GDL || false
        }));
        console.log("transformedData", transformedData);
        setMachineries(transformedData);
      })
      .catch((error) => {
        showToast(
          'Errore durante il caricamento dei macchinari. Riprova più tardi.',
          'error'
        );
      });
  };

  const columns = [
    columnHelper.accessor('name', {
      header: 'Nome macchinario',
      size: 350,
      Cell: ({ row }) => (
        <MDTypography variant="caption" fontWeight="medium">
          {row.original.name}
        </MDTypography>
      ),
    }),
    columnHelper.accessor('supplier', {
      header: 'Fornitore',
      size: 350,
      Cell: ({ row }) => (
        <MDTypography variant="caption">
          {row.original?.supplier?.name || ''}
        </MDTypography>
      ),
    }),
  ];

  const handleCopy = () => {
    const selectedMachineries = machineries.filter(m => m.selected);
    onCopyMachineries(selectedMachineries);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <MDTypography variant="h6">Copia macchinari da data precedente</MDTypography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center', my: 2 }}>
          <Calendar
            onChange={handleDateChange}
            value={selectedDate}
            tileDisabled={tileDisabled}
            maxDate={new Date()}
            className="custom-calendar"
          />
          
          <MDTypography fontWeight="bold" textTransform="uppercase">
            Data selezionata:
            <br />
            {selectedDate.toLocaleDateString('it-IT', {
              weekday: 'long',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            })}
          </MDTypography>

          {machineries.length > 0 && (
            <>
              <GenericTable
                data={machineries}
                columns={columns}
                enableRowSelection={true}
                enableColumnFilters={false}
                enableGlobalFilter={true}
                enablePagination={true}
                disableButton={true}
                initialSelectedAll={true}

                onRowSelectionChange={(selectedRows) => {
                  const updatedMachineries = machineries.map(machine => ({
                    ...machine,
                    selected: selectedRows.some(row => row.id === machine.id)
                  }));
                  setMachineries(updatedMachineries);
                }}
              />

              <Button
                variant="contained"
                color="primary"
                onClick={handleCopy}
                sx={{
                  backgroundColor: '#514f4f',
                  color: 'white!important',
                  width: '220px',
                  height: '50px',
                  fontSize: '16px',
                }}
              >
                Copia macchinari selezionati
              </Button>
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default MachineryDateCopy; 